export default "__VITE_ASSET__DNp7Ph9M__"